export const inputStyle = {
	wrapper: {
		position: 'relative',

		input: {
			'&[type=number]::-webkit-inner-spin-button': {
				display: 'none',
			},
		},
	} as any,
};
